import axios from "axios";

export const register = async (fields: any) => {
  return await axios.post("/submit", fields, {
    baseURL: "https://api-cai.tecorien.com",
  });
};
